declare const __API_BASE__: string;

const runtimeBase = (window as any).__RUNTIME_API_BASE__;

export const API_BASE = runtimeBase || (typeof __API_BASE__ !== "undefined" ? __API_BASE__ : "");

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export function wsUrl(path: string): string {
  const base = API_BASE || window.location.origin;
  const url = new URL(path, base);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}
